import React from 'react';
import _ from 'lodash';
import { RPCFactory } from '../../../utils/RequestUtil';
import LeadsEditableFieldType from '../../../consts/LeadsEditableFieldType';
import { Sex } from '../../../consts/Sex';

import { Column, Dialog, Input, OverlayTrigger, PopOver, Select, Table, TabPanel, Tabs } from '@tencent/spaui';
import { leadsSourceMap } from '../../pages/setting/clue/leadsSourceMap';
import { store } from '../../../store/Store';
import { LeadsManageAction } from '../../../actions/LeadsManageAction';

import { isSubAccount } from '../../../consts/multiAccountConfig';

/**
 * 基础信息
 */
export default class LeadsBaseInfoTab extends React.Component {
  componentDidMount() {
    // RPCFactory.leadsManage.getLeadsOneToOneTagInfo (window.pageProps.uid, this.props.leadsId).done ((data) => {
    // 	this.setState ({leadsTouchTag: data.leadsTouchTag});
    // });
  }

  /**
   *
   * @param props
   * props.leadsId 传入线索Id
   */
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      editName: false,
      editSex: false,
      editArea: false,
      editTel: false,
      editEmail: false,
      editQQ: false,
      editWechat: false,
      invalidLeadsPayUser: true,
      editAge: false,
      editProfession: false,
      editWorkingYears: false,
      editIdNumber: false,
      editAddress: false,
      editNationality: false,
      name: '',
      tel: '',
      area: '',
      sex: '',
      email: '',
      qq: '',
      wechat: '',
      memo: '',
      age: '',
      profession: '',
      workingYears: '',
      idNumber: '',
      address: '',
      nationality: '',
      relatedLeadsIds: '',
      relatedLeadsInfos: '',

      nameEditValue: '',
      telEditValue: '',
      areaEditValue: '',
      sexEditValue: '',
      emailEditValue: '',
      qqEditValue: '',
      ageEditValue: '',
      workingYearsEditValue: '',
      professionEditValue: '',
      idNumberEditValue: '',
      addressEditValue: '',
      nationalityEditValue: '',
      wechatEditValue: '',
      memoEditValue: '',
      bundleEditValue: '',
      bundleEditValues: {},
      bundleName: '',

      base: {},
      bundle: {},
      action: {},

      // 可编辑的自定义属性
      customizedAttributes: [],
      // 已保存的自定义属性
      customizedAttributesValue: [],
      customizedAttributeEditName: '',
      customizedAttributeEditValue: '',

      editBaseInfos: [
        { name: '姓名', field: LeadsEditableFieldType.NAME },
        { name: '微信', field: LeadsEditableFieldType.WECHAT },
        { name: 'QQ', field: LeadsEditableFieldType.QQ },
        { name: '电话', field: LeadsEditableFieldType.TEL },
        { name: '邮箱', field: LeadsEditableFieldType.EMAIL },
        { name: '身份证', field: LeadsEditableFieldType.ID_NUMBER },
        { name: '性别', field: LeadsEditableFieldType.SEX },
        { name: '年龄', field: LeadsEditableFieldType.AGE },
        { name: '职业', field: LeadsEditableFieldType.PROFESSION },
        { name: '工作年限', field: LeadsEditableFieldType.WORKING_YEARS },
        { name: '国籍', field: LeadsEditableFieldType.NATIONALITY },
        { name: '所在地', field: LeadsEditableFieldType.AREA },
        { name: '详细地址', field: LeadsEditableFieldType.ADDRESS },
        { name: '备注', field: LeadsEditableFieldType.MEMO },
      ],

      claimInfo: {},
      editFiledTarget: null,
      editFiledDiaglogShow: false,
      curEditFiled: null,

      adId: '',
      adName: '',
      campaignId: '',
      campaignName: '',
      creativeId: '',
      creativeName: '',
      creativeIdNew: '',
      creativeNameNew: '',
      adCreativeId: '',
      adCreativeName: '',
      placementShortId: '', //广告位短id
      placementName: '', // 广告位名称
      pageUrl: '',
      pageId: '',
      pageName: '',
      componentId: '',
      componentName: '',
      sourceLeadsId: '',
      sourceAccountId: '',
      lgMethod: '',
    };

    RPCFactory.leadsManage.getConversion_claim_agg(this.props.leadsId).done((data) => {
      if (data.claimInfo) {
        this.setState({
          adId: data.claimInfo.adId,
          adName: data.claimInfo.adName,
          campaignId: data.claimInfo.campaignId,
          campaignName: data.claimInfo.campaignName,
          creativeId: data.claimInfo.creativeId,
          creativeName: data.claimInfo.creativeName,
          creativeIdNew: data.claimInfo.creativeIdNew,
          creativeNameNew: data.claimInfo.creativeNameNew,
          adCreativeId: data.claimInfo.adCreativeId,
          adCreativeName: data.claimInfo.adCreativeName,
          placementShortId: data.claimInfo.placementShortId,
          placementName: data.claimInfo.placementName,
          componentId: data.claimInfo.componentId,
          componentName: data.claimInfo.componentName,
        });
      }
      if (data.pageInfo) {
        this.setState({
          pageUrl: data.pageInfo.pageUrl,
          pageId: data.pageInfo.pageId,
          pageName: data.pageInfo.pageName,
        });
      }
    });

    RPCFactory.leadsManage.getLeadsContactAction(this.props.leadsId).done((data) => {
      if (data.contactInfo) {
        this.setState({
          tel:
            !data.contactInfo.telLocation || data.contactInfo.telLocation.length === 0
              ? data.contactInfo.tel
              : `${data.contactInfo.tel}（${data.contactInfo.telLocation}）`,
          area: data.contactInfo.area,
          sex: data.contactInfo.sex,
          email: data.contactInfo.email,
          qq: data.contactInfo.qq,
          age: data.contactInfo.age,
          profession: data.contactInfo.profession,
          workingYears: data.contactInfo.workingYears,
          idNumber: data.contactInfo.idNumber,
          address: data.contactInfo.address,
          nationality: data.contactInfo.nationality,
          wechat: data.contactInfo.wechat,
          name: data.contactInfo.name || '',
          invalidLeadsPayUser: data.invalidLeadsPayUser,
        });
      }

      if (data.leadsInfo.bundle) {
        this.setState({
          base: data.leadsInfo,
          bundle: JSON.parse(JSON.parse(data.leadsInfo.bundle)),
          memo: data.leadsInfo.memo,
        });
      }
      if (data.claimInfo) {
        this.setState({
          claimInfo: data.claimInfo,
        });
      }
      if (data.actionInfo) {
        this.setState({
          action: data.actionInfo,
        });
      }
      if (data.leadsInfo) {
        this.setState({
          relatedLeadsIds: data.leadsInfo.relatedLeadsIds,
          relatedLeadsInfos: data.leadsInfo.relatedLeadsInfos,
          sourceAccountId: data.leadsInfo.sourceAccountId, // 来源广告主ID
          sourceLeadsId: data.leadsInfo.sourceLeadsId, // 来源线索ID
          lgMethod: data.leadsInfo.lgMethod, // LG处理方式 1-线索清洗 2-线索抽检
          memo: data.leadsInfo.memo,
        });
      }

      const { customizedAttributes: customizedAttributesValue = [] } = data;
      this.setState({
        customizedAttributesValue,
      });
    });

    RPCFactory.accountSettings.getCustomizedAttributes().done((data) => {
      const { customizedAttributes = [] } = data;
      this.setState({
        customizedAttributes,
      });
    });

    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(event, value) {
    this.setState({
      value,
    });
  }

  onToggleEditParam = (leadsContactFieldType, editStatus) => {
    this.setState({
      [leadsContactFieldType.getName().concat('EditValue')]: this.state[leadsContactFieldType.getName()],
    });
    switch (leadsContactFieldType) {
      case LeadsEditableFieldType.NAME:
        this.setState({ editName: editStatus });
        break;
      case LeadsEditableFieldType.SEX:
        this.setState({ editSex: editStatus });
        break;
      case LeadsEditableFieldType.AREA:
        this.setState({ editArea: editStatus });
        break;
      case LeadsEditableFieldType.TEL:
        this.setState({ editTel: editStatus });
        break;
      case LeadsEditableFieldType.EMAIL:
        this.setState({ editEmail: editStatus });
        break;
      case LeadsEditableFieldType.QQ:
        this.setState({ editQQ: editStatus });
        break;
      case LeadsEditableFieldType.WECHAT:
        this.setState({ editWechat: editStatus });
        break;
      case LeadsEditableFieldType.MEMO:
        this.setState({ editMemo: editStatus });
        break;
      case LeadsEditableFieldType.AGE:
        this.setState({ editAge: editStatus });
        break;

      case LeadsEditableFieldType.PROFESSION:
        this.setState({ editProfession: editStatus });
        break;
      case LeadsEditableFieldType.WORKING_YEARS:
        this.setState({ editWorkingYears: editStatus });
        break;
      case LeadsEditableFieldType.ID_NUMBER:
        this.setState({ editIdNumber: editStatus });
        break;
      case LeadsEditableFieldType.ADDRESS:
        this.setState({ editAddress: editStatus });
        break;
      case LeadsEditableFieldType.NATIONALITY:
        this.setState({ editNationality: editStatus });
        break;
      default:
        break;
    }
  };

  confirmSuccessSetContactState = (leadsContactFieldType, value) => {
    this.setState({ [leadsContactFieldType.getName()]: value });
  };

  onChangeParam = (value, leadsContactFieldType) => {
    if (leadsContactFieldType.id == 14) {
      this.setState({ bundleEditValue: value, bundleEditValues: { [this.state.bundleName]: value } });
    } else if (leadsContactFieldType.id === 1002) {
      this.setState({ customizedAttributeEditValue: value });
    } else {
      this.setState({ [leadsContactFieldType.getName().concat('EditValue')]: value });
    }
  };

  onConfirm = (leadsContactFieldType) => {
    this.toggleBtnLoading(leadsContactFieldType.getName(), true);
    if (leadsContactFieldType.getId() == LeadsEditableFieldType.MEMO.getId()) {
      RPCFactory.leadsManage
        .updateLeadsInfoField(
          leadsContactFieldType.getId(),
          this.state[leadsContactFieldType.getName().concat('EditValue')],
          this.props.leadsId,
        )
        .done((data) => {
          this.toggleBtnLoading(leadsContactFieldType.getName(), false);
          this.confirmSuccessSetContactState(
            leadsContactFieldType,
            this.state[leadsContactFieldType.getName().concat('EditValue')],
          );
          this.onToggleEditParam(leadsContactFieldType, false);
          this.closeEditFiledDiaglog();
          // 更新父列表字段
          store.dispatch({
            type: LeadsManageAction.UPDATE_SINGLE_LEADS,
            updateType: leadsContactFieldType,
            targetValue: this.state[leadsContactFieldType.getName().concat('EditValue')],
            targetLeadsId: this.props.leadsId,
          });
        })
        .fail((ret, msg) => {
          window.alert(`更新失败，${msg}`);
          this.toggleBtnLoading(leadsContactFieldType.getName(), false);
        });
    } else if (leadsContactFieldType.getId() == LeadsEditableFieldType.BUNDLES.getId()) {
      RPCFactory.leadsManage
        .updateLeadsInfoField(
          14,
          JSON.stringify(Object.assign(this.state.bundle, this.state.bundleEditValues)),
          this.props.leadsId,
        )
        .done((data) => {
          let { bundle } = this.state;
          const { base } = this.state;
          bundle = Object.assign(bundle, this.state.bundleEditValues);
          this.setState({
            bundle,
          });
          this.closeEditFiledDiaglog();
          this.toggleBtnLoading(leadsContactFieldType.getName(), false);
          this.onToggleEditBundleField(leadsContactFieldType.getName(), false);
          //
          // // 更新父列表字段
          store.dispatch({
            type: LeadsManageAction.UPDATE_SINGLE_LEADS,
            updateType: LeadsEditableFieldType.BUNDLES,
            targetValue: bundle,
            targetLeadsId: this.props.leadsId,
          });
        })
        .fail((ret, msg) => {
          window.alert(`更新失败，${msg}`);
          this.toggleBtnLoading(leadsContactFieldType.getName(), false);
        });
    } else if (leadsContactFieldType.getId() === LeadsEditableFieldType.CUSTOMIZED_ATTRIBUTE.getId()) {
      const { customizedAttributeEditName, customizedAttributeEditValue } = this.state;
      RPCFactory.leadsManage
        .updateLeadsCustomizedAttributes(this.props.leadsId, customizedAttributeEditName, customizedAttributeEditValue)
        .done((data) => {
          const { customizedAttributes, customizedAttributesValue } = this.state;
          const list = [...customizedAttributesValue];
          const index = _.findIndex(list, (v) => v.name === customizedAttributeEditName);
          if (index > -1) {
            list[index].value = customizedAttributeEditValue;
            // 来源为人工
            list[index].source = 2;
          } else {
            const item = _.find(customizedAttributes, (v) => v.name === customizedAttributeEditName) || {};
            item.value = customizedAttributeEditValue;
            // 来源为人工
            item.source = 2;
            list.push(item);
          }
          this.setState({
            customizedAttributesValue: list,
            customizedAttributeEditValue: '',
          });
          this.closeEditFiledDiaglog();
          this.toggleBtnLoading(leadsContactFieldType.getName(), false);
          this.onToggleEditBundleField(leadsContactFieldType.getName(), false);
          // 更新父列表字段
          store.dispatch({
            type: LeadsManageAction.UPDATE_SINGLE_LEADS,
            updateType: LeadsEditableFieldType.CUSTOMIZED_ATTRIBUTE,
            targetValue: customizedAttributesValue,
            targetLeadsId: this.props.leadsId,
          });
        })
        .fail((ret, msg) => {
          this.setState({
            customizedAttributeEditValue: '',
          });
          window.alert(`更新失败，${msg}`);
          this.toggleBtnLoading(leadsContactFieldType.getName(), false);
        });
    } else {
      RPCFactory.leadsManage
        .updateLeadsContactInfo(
          window.pageProps.uid,
          this.props.leadsId,
          leadsContactFieldType.getId(),
          this.state[leadsContactFieldType.getName().concat('EditValue')],
        )
        .done((data) => {
          this.toggleBtnLoading(leadsContactFieldType.getName(), false);
          this.confirmSuccessSetContactState(
            leadsContactFieldType,
            this.state[leadsContactFieldType.getName().concat('EditValue')],
          );
          this.onToggleEditParam(leadsContactFieldType, false);
          this.closeEditFiledDiaglog();

          // 更新父列表字段
          store.dispatch({
            type: LeadsManageAction.UPDATE_SINGLE_LEADS,
            updateType: leadsContactFieldType,
            targetValue: this.state[leadsContactFieldType.getName().concat('EditValue')],
            targetLeadsId: this.props.leadsId,
          });
        })
        .fail((ret, msg) => {
          window.alert(`更新失败，${msg}`);
          this.toggleBtnLoading(leadsContactFieldType.getName(), false);
        });
    }
  };

  onCancel = (leadsContactFieldType) => {
    this.onToggleEditParam(leadsContactFieldType, false);
  };

  toggleBtnLoading = (key, loadingStatus) => {
    this.setState({ [key.concat('Loading')]: loadingStatus });
  };

  /**
   * =====================================================================
   * bundle编辑部分
   */
  onToggleEditBundleField = (key, editStatus) => {
    // 将真实的值，赋给输入框
    const bundle = JSON.parse(this.state.base.bundle);
    this.setState({
      [key.concat('EditValue')]: bundle[key],
      ['edit'.concat(key)]: editStatus,
    });
  };

  onChangeBundleParam = (value, key) => {
    this.setState({ [key.concat('EditValue')]: value });
  };

  onBundleConfirm = (key) => {
    this.toggleBtnLoading(key, true);
    RPCFactory.leadsManage
      .updateLeadsBundle(this.props.leadsId, key, this.state[key.concat('EditValue')])
      .done((data) => {
        const bundle = JSON.parse(this.state.base.bundle);
        const { base } = this.state;
        bundle[key] = this.state[key.concat('EditValue')];
        base.bundle = JSON.stringify(bundle);
        this.setState({
          base,
          [key.concat('Loading')]: false,
        });
        this.toggleBtnLoading(key, false);
        this.onToggleEditBundleField(key, false);

        // 更新父列表字段
        store.dispatch({
          type: LeadsManageAction.UPDATE_SINGLE_LEADS,
          updateType: LeadsEditableFieldType.BUNDLE,
          targetValue: base.bundle,
          targetLeadsId: this.props.leadsId,
        });
      })
      .fail((ret, msg) => {
        window.alert(`更新失败，${msg}`);
        this.toggleBtnLoading(key, false);
        this.onToggleEditBundleField(key, false);
      });
  };

  editFiled = (target, item) => {
    if (item.field.id == 14) {
      this.setState({ bundleName: item.name });
    }
    if (item.field.id === 1002) {
      this.setState({ customizedAttributeEditName: item.name });
    }
    this.setState({ editFiledTarget: target, editFiledDiaglogShow: true, curEditFiled: item });
  };
  closeEditFiledDiaglog() {
    this.setState({ editFiledTarget: null, editFiledDiaglogShow: false, curEditFiled: null });
  }
  submitEditFiledDiaglog() {}

  /**
   * bundle编辑部分
   * =====================================================================
   */

  render() {
    const { value } = this.state;
    // const sex = Sex[this.state.sex] ? Sex[this.state.sex] : "";
    const sexSelect = [];
    Object.keys(Sex).forEach((key) => {
      sexSelect.push({ value: key, label: Sex[key] });
    });

    const canEdit =
      window.pageProps.operatorRole != 'OPERATOR_ROLE_LEADS_AGENCY' &&
      window.pageProps.operatorRole != 'OPERATOR_ROLE_LEADS_ADOPERATOR' &&
      window.pageProps.operatorRole != 'OPERATOR_ROLE_LEADS_ASSISTANT' &&
      !isSubAccount();

    const bundleElements = []; // 保存每个用户渲染以后 JSX 的数组

    let leadsSourceName = '';
    if (this.state.base.leadsSource) {
      leadsSourceName = leadsSourceMap[this.state.base.leadsSource];
    }
    let leadSouceType = '';
    if (this.state.action.actionType == 3) {
      leadSouceType = '咨询';
    } else if (this.state.action.actionType == 15) {
      leadSouceType = '表单线索';
    }

    const popoverstyle = {
      maxWidth: '550px',
    };
    const tips = [];
    if (
      this.state.relatedLeadsIds != undefined &&
      this.state.relatedLeadsIds != '' &&
      this.state.relatedLeadsInfos != undefined &&
      this.state.relatedLeadsInfos != ''
    ) {
      this.state.relatedLeadsInfos.forEach((e) => {
        tips.push({ leadsId: e.leadsId, leadsTel: e.tel, leadsActionTime: e.actionTime });
      });
    }
    const popover = (
      <PopOver style={popoverstyle}>
        <div className="poptable">
          <Table hideThead={false} data={tips}>
            <Column name="leadsId" minWidth={80}>
              <strong>线索ID</strong>
            </Column>
            <Column name="leadsTel">
              <strong>电话</strong>
            </Column>
            <Column name="leadsActionTime" minWidth={80}>
              <strong>线索提交时间</strong>
            </Column>
          </Table>
        </div>
      </PopOver>
    );

    const { editBaseInfos } = this.state;
    const editBaseInfosElement = [];
    if (editBaseInfos) {
      editBaseInfos.forEach((e) => {
        editBaseInfosElement.push(
          <li className="clearfix">
            <span className="tt">{e.name}</span>
            <div className="desc">
              <p className="line">
                {e.field.getName() != 'sex' && (
                  <span className="in">
                    {this.state[e.field.getName()] ? this.state[e.field.getName()] : '--'}
                    {e.field.getName() == 'tel' &&
                      this.state.relatedLeadsIds != undefined &&
                      this.state.relatedLeadsIds != '' && (
                        <OverlayTrigger trigger="hover" delay={100} overlay={popover}>
                          <i className="icon icon-help" style={{ opacity: 1 }}>
                            <i></i>
                          </i>
                        </OverlayTrigger>
                      )}
                  </span>
                )}
                {e.field.getName() == 'sex' && (
                  <span className="in">
                    {Sex[this.state[e.field.getName()]] ? Sex[this.state[e.field.getName()]] : '--'}
                  </span>
                )}
                {canEdit && (
                  <i
                    onClick={(evt) => {
                      this.editFiled(evt.target, e);
                    }}
                    className="icon icon-pen"
                  ></i>
                )}
              </p>
            </div>
          </li>,
        );
      });
    }

    if (this.state.base.bundle) {
      const { bundle } = this.state;
      /**
       * 每个key有两个state关键值：
       * 1、edit{key}, 编辑态标志位
       * 2、{key}EditValue 编辑框中的值
       *
       * 三个关键方法：
       * 1、onToggleEditBundleField，变更编辑态
       * 2、onChangeBundleParam， 输入框变更
       * 3、onBundleConfirm，确认编辑
       */
      Object.keys(bundle).forEach((key) => {
        editBaseInfosElement.push(
          <li className="clearfix">
            <span className="tt">{key}</span>
            <div className="desc">
              <p className="line">
                <span className="in">{bundle[key] ? bundle[key] : '--'}</span>
                {canEdit && (
                  <i
                    onClick={(evt) => this.editFiled(evt.target, { name: key, field: { name: 'bundle', id: 14 } })}
                    className="icon icon-pen"
                  ></i>
                )}
              </p>
            </div>
          </li>,
        );
      });
    }

    // 自定义属性
    const { customizedAttributes, customizedAttributesValue } = this.state;
    customizedAttributes.forEach((v) => {
      const { name } = v;
      const item = _.find(customizedAttributesValue, (x) => x.name === name) || {};
      const { value = '--', source } = item;
      const sourceMap = {
        1: '系统标注',
        2: '人工标注',
      };
      editBaseInfosElement.push(
        <li className="clearfix">
          <span className="tt">{name}</span>
          <div className="desc">
            <p className="line">
              <span className="in">{value}</span>
              {source ? <span>（{sourceMap[source] || ''}）</span> : null}
              {canEdit && (
                <i
                  onClick={(e) => this.editFiled(e.target, { name, field: { name: 'customizedAttribute', id: 1002 } })}
                  className="icon icon-pen"
                ></i>
              )}
            </p>
          </div>
        </li>,
      );
    });

    // const claimInfo = this.state.claimInfo;
    // const claimInfoElement = [];
    // if (claimInfo) {
    // 	// claimInfo.forEach ((key,value) => {
    // 	// 	claimInfoElement.push (
    // 	// 		<li className="clearfix">
    // 	// 			<span className="tt">{key}</span>
    // 	// 			<span className="desc">
    // 	// 				{value}
    // 	// 			</span>
    // 	// 		</li>
    // 	// 	);
    // 	// })
    // }
    const editElement = [];
    let editElementTitle = '';
    let curFiled = null;
    if (this.state.curEditFiled) {
      curFiled = this.state.curEditFiled.field;
      editElementTitle = this.state.curEditFiled.name;
      if (curFiled == LeadsEditableFieldType.NAME) {
        editElement.push(
          <Input
            size="small"
            maxLength="10"
            onChange={(event, value) => {
              this.onChangeParam(value, LeadsEditableFieldType.NAME);
            }}
            value={this.state.nameEditValue}
          ></Input>,
        );
      } else if (curFiled == LeadsEditableFieldType.SEX) {
        editElement.push(
          <Select
            data={sexSelect}
            onChange={(event, value) => {
              this.onChangeParam(value, LeadsEditableFieldType.SEX);
            }}
            value={this.state.sexEditValue}
          ></Select>,
        );
      } else if (curFiled == LeadsEditableFieldType.AREA) {
        editElement.push(
          <Input
            size="small"
            onChange={(event, value) => {
              this.onChangeParam(value, LeadsEditableFieldType.AREA);
            }}
            value={this.state.areaEditValue}
          ></Input>,
        );
      } else if (curFiled == LeadsEditableFieldType.TEL) {
        editElement.push(
          <Input
            size="small"
            onChange={(event, value) => {
              this.onChangeParam(value, LeadsEditableFieldType.TEL);
            }}
            value={this.state.telEditValue}
          ></Input>,
        );
      } else if (curFiled == LeadsEditableFieldType.EMAIL) {
        editElement.push(
          <Input
            size="small"
            onChange={(event, value) => {
              this.onChangeParam(value, LeadsEditableFieldType.EMAIL);
            }}
            value={this.state.emailEditValue}
          ></Input>,
        );
      } else if (curFiled == LeadsEditableFieldType.QQ) {
        editElement.push(
          <Input
            size="small"
            onChange={(event, value) => {
              this.onChangeParam(value, LeadsEditableFieldType.QQ);
            }}
            value={this.state.qqEditValue}
          ></Input>,
        );
      } else if (curFiled == LeadsEditableFieldType.AGE) {
        editElement.push(
          <Input
            size="small"
            onChange={(event, value) => {
              this.onChangeParam(value, LeadsEditableFieldType.AGE);
            }}
            value={this.state.ageEditValue}
          ></Input>,
        );
      } else if (curFiled == LeadsEditableFieldType.PROFESSION) {
        editElement.push(
          <Input
            size="small"
            onChange={(event, value) => {
              this.onChangeParam(value, LeadsEditableFieldType.PROFESSION);
            }}
            value={this.state.professionEditValue}
          ></Input>,
        );
      } else if (curFiled == LeadsEditableFieldType.WORKING_YEARS) {
        editElement.push(
          <Input
            size="small"
            onChange={(event, value) => {
              this.onChangeParam(value, LeadsEditableFieldType.WORKING_YEARS);
            }}
            value={this.state.workingYearsEditValue}
          ></Input>,
        );
      } else if (curFiled == LeadsEditableFieldType.ID_NUMBER) {
        editElement.push(
          <Input
            size="small"
            onChange={(event, value) => {
              this.onChangeParam(value, LeadsEditableFieldType.ID_NUMBER);
            }}
            value={this.state.idNumberEditValue}
          ></Input>,
        );
      } else if (curFiled == LeadsEditableFieldType.ADDRESS) {
        editElement.push(
          <Input
            size="small"
            onChange={(event, value) => {
              this.onChangeParam(value, LeadsEditableFieldType.ADDRESS);
            }}
            value={this.state.addressEditValue}
          ></Input>,
        );
      } else if (curFiled == LeadsEditableFieldType.NATIONALITY) {
        editElement.push(
          <Input
            size="small"
            onChange={(event, value) => {
              this.onChangeParam(value, LeadsEditableFieldType.NATIONALITY);
            }}
            value={this.state.nationalityEditValue}
          ></Input>,
        );
      } else if (curFiled == LeadsEditableFieldType.WECHAT) {
        editElement.push(
          <Input
            size="small"
            onChange={(event, value) => {
              this.onChangeParam(value, LeadsEditableFieldType.WECHAT);
            }}
            value={this.state.wechatEditValue}
          ></Input>,
        );
      } else if (curFiled == LeadsEditableFieldType.MEMO) {
        editElement.push(
          <Input
            size="small"
            onChange={(event, value) => {
              this.onChangeParam(value, LeadsEditableFieldType.MEMO);
            }}
            value={this.state.memoEditValue}
          ></Input>,
        );
      } else if (curFiled.id == 14) {
        curFiled = LeadsEditableFieldType.BUNDLES;
        editElement.push(
          <Input
            size="small"
            onChange={(event, value) => {
              this.onChangeParam(value, LeadsEditableFieldType.BUNDLES);
            }}
            value={this.state.bundleEditValue}
          ></Input>,
        );
      } else if (curFiled.id === 1002) {
        curFiled = LeadsEditableFieldType.CUSTOMIZED_ATTRIBUTE;
        const { customizedAttributes, customizedAttributeEditName, customizedAttributeEditValue } = this.state;
        const item = _.find(customizedAttributes, (v) => v.name === customizedAttributeEditName) || {};
        const { options = [] } = item;
        if (item.type === 'TEXT') {
          editElement.push(
            <Input
              size="small"
              onChange={(event, value) => {
                this.onChangeParam(value, LeadsEditableFieldType.CUSTOMIZED_ATTRIBUTE);
              }}
              value={customizedAttributeEditValue}
            ></Input>,
          );
        } else {
          editElement.push(
            <Select
              data={options}
              onChange={(event, value) => {
                this.onChangeParam(value, LeadsEditableFieldType.CUSTOMIZED_ATTRIBUTE);
              }}
              value={customizedAttributeEditValue}
            ></Select>,
          );
        }
        // 近期购买意向，到店时间，预算量级
      }
    }
    return (
      <div>
        <Tabs onChange={this.handleChange} value={value} needSlider={false}>
          <TabPanel tab="用户信息" name={0}>
            <ul className="infolist" style={{ marginBottom: '160px' }}>
              {editBaseInfosElement}
            </ul>
          </TabPanel>
          <TabPanel tab="广告投放信息" name="1">
            <ul className="infolist" style={{ marginBottom: '160px' }}>
              <li className="clearfix">
                <span className="tt">推广计划</span>
                <span className="desc">
                  <p className="line">
                    <span className="in">{this.state.campaignName ? this.state.campaignName : '--'}</span>
                  </p>
                  <p className="line">
                    <span className="in">ID:{this.state.campaignId ? this.state.campaignId : '--'}</span>
                  </p>
                </span>
              </li>
              <li className="clearfix">
                <span className="tt">广告</span>
                <span className="desc">
                  <p className="line">
                    <span className="in">{this.state.adName ? this.state.adName : '--'}</span>
                  </p>
                  <p className="line">
                    <span className="in">ID:{this.state.adId ? this.state.adId : '--'}</span>
                  </p>
                </span>
              </li>
              <li className="clearfix">
                <span className="tt">创意(待废弃)</span>
                <span className="desc">
                  <p className="line">
                    <span className="in">{this.state.creativeName ? this.state.creativeName : '--'}</span>
                  </p>
                  <p className="line">
                    <span className="in">ID:{this.state.creativeId ? this.state.creativeId : '--'}</span>
                  </p>
                </span>
              </li>
              <li className="clearfix">
                <span className="tt">投放端创意</span>
                <span className="desc">
                  <p className="line">
                    <span className="in">{this.state.creativeNameNew ? this.state.creativeNameNew : '--'}</span>
                  </p>
                  <p className="line">
                    <span className="in">ID:{this.state.creativeIdNew ? this.state.creativeIdNew : '--'}</span>
                  </p>
                </span>
              </li>
              <li className="clearfix">
                <span className="tt">mkt api创意</span>
                <span className="desc">
                  <p className="line">
                    <span className="in">{this.state.adCreativeName ? this.state.adCreativeName : '--'}</span>
                  </p>
                  <p className="line">
                    <span className="in">ID:{this.state.adCreativeId ? this.state.adCreativeId : '--'}</span>
                  </p>
                </span>
              </li>
              {/*详情页 add by fighting*/}
              <li className="clearfix">
                <span className="tt">广告位</span>
                <span className="desc">
                  <p className="line">
                    <span className="in">{this.state.placementName ? this.state.placementName : '--'}</span>
                  </p>
                  <p className="line">
                    <span className="in">ID:{this.state.placementShortId ? this.state.placementShortId : '--'}</span>
                  </p>
                </span>
              </li>
              <li className="clearfix">
                <span className="tt">落地页</span>
                <span className="desc">
                  <p className="line">
                    <span className="in">{this.state.pageName ? this.state.pageName : '--'}</span>
                  </p>
                  <p className="line">
                    <span className="in">ID:{this.state.pageId ? this.state.pageId : '--'}</span>
                  </p>
                </span>
              </li>
              <li className="clearfix">
                <span className="tt">组件</span>
                <span className="desc">
                  <p className="line">
                    <span className="in">{this.state.componentName ? this.state.componentName : '--'}</span>
                  </p>
                  <p className="line">
                    <span className="in">ID:{this.state.componentId ? this.state.componentId : '--'}</span>
                  </p>
                </span>
              </li>
              <li className="clearfix">
                <span className="tt">推广链接</span>
                <span className="desc">
                  <span className="in">
                    {this.state.pageUrl && (
                      <a href={this.state.pageUrl} target="_blank" rel="noreferrer">
                        {this.state.pageUrl}
                      </a>
                    )}
                    {!this.state.pageUrl && '--'}
                  </span>
                </span>
              </li>
            </ul>
          </TabPanel>
          {window.pageProps.isInnerAccount && (
            <TabPanel tab="内部信息" name="2">
              <ul className="infolist" style={{ marginBottom: '160px' }}>
                <li className="clearfix">
                  <span className="tt">LG处理方式</span>
                  <span className="desc">
                    <p className="line">
                      <span className="in">
                        {this.state.lgMethod === 1 ? '线索清洗' : this.state.lgMethod === 2 ? '线索抽检' : '--'}
                      </span>
                    </p>
                  </span>
                </li>
                <li className="clearfix">
                  <span className="tt">来源广告主账号</span>
                  <span className="desc">
                    <p className="line">
                      <span className="in">{this.state.sourceAccountId ? this.state.sourceAccountId : '--'}</span>
                    </p>
                  </span>
                </li>
                <li className="clearfix">
                  <span className="tt">来源线索ID</span>
                  <span className="desc">
                    <p className="line">
                      <span className="in">{this.state.sourceLeadsId ? this.state.sourceLeadsId : '--'}</span>
                    </p>
                  </span>
                </li>
              </ul>
            </TabPanel>
          )}
        </Tabs>
        <Dialog
          eventTargetPlacement={'auto'}
          eventTarget={this.state.editFiledTarget}
          style={{ width: '300px' }}
          show={this.state.editFiledDiaglogShow}
          onClose={this.closeEditFiledDiaglog.bind(this)}
          onSubmit={this.onConfirm.bind(this, curFiled)}
          onCancel={this.closeEditFiledDiaglog.bind(this)}
          title={editElementTitle}
          className="modal-w300 modal-simple"
        >
          <div>{editElement}</div>
        </Dialog>
      </div>
    );
  }
}
